import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Receipt, DownloadSimple } from "@phosphor-icons/react";

export default function Invoices() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/company/invoices").then((r) => setItems(r.data)); }, []);
  const download = (month) => {
    // Use fetch to include credentials, then trigger download
    fetch(`${API}/company/invoices/${month}.pdf`, { credentials: "include" })
      .then(r => r.blob())
      .then(b => {
        const url = URL.createObjectURL(b);
        const a = document.createElement("a");
        a.href = url; a.download = `ShiftFlex-${month}.pdf`; a.click();
        URL.revokeObjectURL(url);
      });
  };
  return (
    <div className="space-y-4 max-w-3xl">
      <div className="flex items-center gap-3">
        <Receipt size={28} className="text-blue-600" />
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900">Invoices</h1>
      </div>
      <p className="text-slate-600">Monthly summaries of paid shifts. Download PDF for your accountant.</p>
      <div className="space-y-2">
        {items.length === 0 && <div className="card-tactile p-8 text-center text-slate-500">No paid shifts yet.</div>}
        {items.map((m) => (
          <div key={m.month} className="card-tactile p-5 flex items-center justify-between gap-3 flex-wrap" data-testid={`invoice-${m.month}`}>
            <div>
              <div className="font-display text-xl font-bold text-slate-900">{m.month}</div>
              <div className="text-sm text-slate-600">{m.count} paid shift{m.count === 1 ? "" : "s"}</div>
            </div>
            <div className="flex items-center gap-4">
              <div className="text-right">
                <div className="label-caps">Total</div>
                <div className="font-display text-2xl font-extrabold text-slate-900">£{m.total.toFixed(2)}</div>
              </div>
              <Button data-testid={`invoice-dl-${m.month}`} onClick={() => download(m.month)} className="bg-blue-600 hover:bg-blue-700">
                <DownloadSimple size={16} className="mr-1.5"/> PDF
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
